// Prices always come formatted for monthly payments, except for hourly costs
export const FREQUENCY_PRICE_DICTIONARY = {
  monthly: 'price.per.month',
  costPerHour: 'price.per.hour',
  weekly: 'price.per.month',
  biMonthly: 'price.per.month'
};

export const FREQUENCY_DICTIONARY = {
  onePayment: 'payment.timeline.frequency.onePayment',
  monthly: 'payment.timeline.frequency.monthly',
  weekly: 'payment.timeline.frequency.monthly',
  biMonthly: 'payment.timeline.frequency.monthly'
};

export const ICONS_DICTIONARY = {
  contractRegistration: 'check_circle_transparent',
  latePayment: 'verified_card',
  earlyDepartureNoticePeriodBroken: 'event_busy',
  extraTenant: 'perfect_for_couples',
  overnightGuest: 'perfect_for_couples',
  petFee: 'pets_allowed',
  outOfHoursCheckIn: 'faster',
  outOfHoursCheckOut: 'faster',
  checkOutCleaning: 'cleaning_service',
  council: 'bank_court_house',
  local: 'private_landlord',
  building: 'cottage',
  laundry: 'washing_machine',
  streaming: 'tv',
  custom: 'diamond',
  periodicCleaning: 'cleaning_service',
  parking: 'private_parking',
  bedLinen: 'bed_linen',
  meal: 'meal_service'
};

export default {
  FREQUENCY_PRICE_DICTIONARY,
  FREQUENCY_DICTIONARY,
  ICONS_DICTIONARY
};
